module.exports = "<div class=\"card\">\n  <ng-content select=\".card-title\"></ng-content>\n\n  <ng-content select=\".content\"></ng-content>\n</div>\n"